/**
 * Loads the Proseduuri feedback widget for authenticated users only.
 * Embed script mounts at end of document.body (same as a body-end script tag).
 */
import { useEffect } from 'react';

const EMBED_URL = 'https://widgets.proseduuri.cloud/api/widgets/feedback-widget-bgla/embed';
const MARKER = 'data-feedback-widget-bgla';
const ROOT_ID = 'feedback-widget-bgla-root';
const WIDGET_ATTR = 'data-procedures-widget';
const WIDGET_SLUG = 'feedback-widget-bgla';

function removeInjected() {
    document.querySelectorAll(`[${MARKER}]`).forEach((el) => el.remove());
    document.querySelectorAll(`[${WIDGET_ATTR}="${WIDGET_SLUG}"]`).forEach((el) => el.remove());
    const root = document.getElementById(ROOT_ID);
    if (root) root.remove();
    // Module entry loaded by the embed loader (no marker on the tag itself)
    document.querySelectorAll('script[src*="/widgets/feedback-widget/"]').forEach((el) => el.remove());
}

export default function FeedbackWidgetInjector({ enabled, language }) {
    useEffect(() => {
        if (!enabled) {
            removeInjected();
            return undefined;
        }

        removeInjected();

        const script = document.createElement('script');
        const lang = language === 'fi' || language === 'en' || language === 'sv' ? language : null;
        script.src = lang ? `${EMBED_URL}?lang=${encodeURIComponent(lang)}` : EMBED_URL;
        script.async = true;
        script.setAttribute(MARKER, '1');
        document.body.appendChild(script);

        return () => {
            removeInjected();
        };
    }, [enabled, language]);

    return null;
}
